import Button from "components/base/Button";

const DiagnosisCard = ({
  diagnoses,
  selectedDiagnosisId,
  onSelectDiagnosis,
}) => {
  return (
    <div className="xl:col-span-2 card">
      <h5>Why It Changed (Data Diagnosis)</h5>
      <div className="text-xs opacity-60 mt-1">
        Hypotheses with confidence labels. Click one to inspect details.
      </div>
      <div className="mt-3 space-y-2">
        {diagnoses.map((item, index) => (
          <Button
            key={item.id}
            className={`w-full rounded-none justify-start text-left py-3 text-gray-900 dark:text-gray-100 ${
              index < diagnoses.length - 1
                ? "border-b dark:border-gray-700"
                : ""
            } ${
              selectedDiagnosisId === item.id
                ? "bg-sky-50 dark:bg-sky-900/20"
                : ""
            }`}
            onClick={() => onSelectDiagnosis(item.id)}
          >
            <div className="font-semibold">
              {item.entityDisplayName}: {item.subject}
            </div>
            <div className="opacity-70 text-xs mt-1">
              {item.direction === "down" ? "Down" : "Up"} | Confidence:{" "}
              {String(item.confidence || "medium").toUpperCase()}
            </div>
            <div className="mt-1">{item.phenomenon}</div>
            <div className="mt-1 text-xs opacity-70">
              Disproof check: {item.hypothesis}
            </div>
          </Button>
        ))}
        {diagnoses.length === 0 ? (
          <div className="opacity-60">No diagnoses available.</div>
        ) : null}
      </div>
    </div>
  );
};

export default DiagnosisCard;
